import './App.css';
import React from "react";
// import { Card, CardContent } from "./components/ui/card";
// import { Button } from "./components/ui/button.jsx";
// import { Mail, Phone, Printer, PenTool, ScissorsSquare, MapPin } from "lucide-react";
// import { motion } from "framer-motion";

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-amber-100 text-gray-900 font-sans">

      {/* Header Section */}
      <header className="bg-teal-10 py-6 shadow-md">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-5xl font-bold text-gray-600">NALANDA STORES</h1>
        </div>
      </header>

      {/* Main Content Section */}
      <main className="py-12 px-6">
        <div className="max-w-4xl mx-auto bg-white border border-gray-300 rounded-xl p-8 shadow-xl">

          {/* What We Offer Section */}
          <section className="mb-10">
            <h2 className="text-2xl font-semibold mb-4 text-teal-600">What We Offer</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-green-100 p-6 rounded-lg shadow-xl hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105">
                <h3 className="text-xl font-semibold text-teal-700 mb-2">Printing Services</h3>
                <p className="text-sm text-gray-600">Color, B/W, Spiral Binding, Resumes, Photo Prints</p>
              </div>
              <div className="bg-green-100 p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105">
                <h3 className="text-xl font-semibold text-teal-700 mb-2">Stationery & Office Supplies</h3>
                <p className="text-sm text-gray-600">Pens, Files, Notebooks, Stamps, Ink</p>
              </div>
              <div className="bg-green-100 p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105">
                <h3 className="text-xl font-semibold text-teal-700 mb-2">Arts & Crafts</h3>
                <p className="text-sm text-gray-600">Chart Papers, Brushes, Colors, Handmade Items</p>
              </div>
            </div>
          </section>

          {/* Address Section */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-teal-600">Our Location</h2>
            <div className="bg-teal-50 p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 ease-in-out">
              <a href="https://www.google.com/maps/place/Marikkal+Building/@10.0497775,76.282667,15z/data=!4m6!3m5!1s0x3b080d483fda6deb:0x8636ce039c028eea!8m2!3d10.0528688!4d76.2884301!16s%2Fg%2F11n7dtvv56?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D" className="text-base">Marikkal Building, ORA-62,Oppo. Kannamkulam, Vishnupuram, Cheranalloore<br />Kochi, Kerala</a>
            </div>
          </section>
        </div>
      </main>

      {/* Footer Section */}
      <footer className="bg-teal-600 py-6 mt-10">
        <div className="max-w-4xl mx-auto text-center text-black">
          <h2 className="text-xl font-semibold mb-4">Contact Us</h2>
          <div className="bg-teal-50 p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 ease-in-out mx-4">
            <p className="text-base">Phone: <span className="font-medium text-teal-700">+91 94956 03395</span></p>
            <a className="text-base" href='https://mail.google.com/mail/u/0/#inbox?compose=DmwnWsdMWgvlDQdjdgCSTjZFpXBpdxpXCxsqRhgKZpkMpwVLBNlNzmHrQXwvtMFZFwXGsSwwplgv' target='_blank' rel='noopener noreferrer'>Email: <span className="font-medium text-teal-700">nalandachlr@gmail.com</span></a>
            
          </div>
        </div>
      </footer>
    <div>
      
    </div>
    </div>
  );
}

export default App;
